const alertsActions = {
  ALERTS_STATE_INIT: 'ALERTS_STATE_INIT',
  ALERT_ADD: 'ALERT_ADD',
  ALERT_DELETE: 'ALERT_DELETE',
};
export default alertsActions;
